import dot from 'dot-prop-immutable';
import { assocPath } from 'ramda';
import { combineReducers } from 'redux';

const entityById =
  (name) =>
  (state = {}, action) => {
    const isSource = (obj) =>
      obj &&
      Object.prototype.hasOwnProperty.call(obj, 'entities') &&
      Object.prototype.hasOwnProperty.call(obj.entities, name);
    const source = isSource(action.meta)
      ? action.meta
      : isSource(action.payload)
      ? action.payload
      : null;

    return source ? { ...state, ...source.entities[name] } : state;
  };

export const createEntitiesReducer = (names, actionTypes) => {
  const entityReducerByName = names.reduce((acc, name) => {
    acc[name] = entityById(name);
    return acc;
  }, {});
  const reducer = combineReducers(entityReducerByName);
  return (state, action) => {
    let nextState = state;
    if (actionTypes.indexOf(action.type) !== -1) {
      nextState = {
        ...state,
        entities: reducer(state.entities, action),
      };
    }
    for (const name of names) {
      if (!(name in nextState.entities)) {
        nextState = assocPath(['entities', name], {}, nextState);
      }
    }
    return nextState;
  };
};

export const createRehydrateReducer = (getScope, paths) => (state, action) => {
  let scope;
  try {
    scope = getScope({ [action.key]: action.payload });
  } catch (err) {
    return state;
  }
  let nextState = { ...state };
  for (const path of paths) {
    const defaultValue = dot.get(state, path);
    const value = dot.get(scope, path, defaultValue);
    nextState = dot.set(nextState, path, value);
  }
  return nextState;
};
